import FileDownloadOutlined from '@mui/icons-material/FileDownloadOutlined';
import { t } from 'i18next';
import { useCallback, useContext, useState } from 'react';

import { SmallLoadingButton } from '~components/Order/ordersDispatchStyledComponents';
import { useJob } from '~hooks/useJob/useJob';

import FilesQueryContext from '../../FilesQueryContext';
import { getEffectiveJobStates } from '../../utils';

export default function ExportCsvCTA() {
  const { filters } = useContext(FilesQueryContext);
  const { exportApproveJobsCsv } = useJob();
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = useCallback(async () => {
    setIsExporting(true);
    try {
      await exportApproveJobsCsv({
        aiReviewStatuses: filters.aiReviewStatuses,
        driverIds: filters.driverIds,
        vendorAccountIds: filters.vendorAccountIds,
        dropoffSitesIds: filters.dropoffSiteIds,
        pickupSitesIds: filters.pickupSiteIds,
        foremanIds: filters.foremanIds,
        startDate: filters.startDate?.toISOString(),
        endDate: filters.endDate?.toISOString(),
        jobStates: getEffectiveJobStates(filters.jobStates),
        jobApprovalStatus: filters.jobApprovalStatus,
        loadApprovalStatus: filters.loadApprovalStatus,
        materialIds: filters.materialIds,
        prevailingWage: filters.prevailingWage,
        searchQuery: filters.searchQuery,
        ticketPotentialDuplicate: filters.ticketPotentialDuplicate,
        ticketTypes: filters.ticketTypes,
      });
    } finally {
      setIsExporting(false);
    }
  }, [exportApproveJobsCsv, filters]);

  return (
    <SmallLoadingButton
      loading={isExporting}
      onClick={handleExport}
      startIcon={<FileDownloadOutlined />}
      variant="outlined"
      color="secondary"
    >
      {t('approvals.export.export_csv')}
    </SmallLoadingButton>
  );
}
